import combineStyles from './combineStyles';

export default combineStyles;
